export enum PaymentMethodStatus {
    active = 'Active',
    closed = 'Closed',
}
